import { render, staticRenderFns } from "./AdQuizQuestion.vue?vue&type=template&id=2796c747"
import script from "./AdQuizQuestion.vue?vue&type=script&lang=js"
export * from "./AdQuizQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports